import { useTranslation } from '@sortlist-frontend/translation/ssr';
import { useRouter } from 'next/router';
import { Fragment, useState } from 'react';

import { BriefingEmbedButton } from '_components/Briefing/components/BriefingEmbedButton';
import { BriefingDialog } from '_components/Briefing/versions/NormalBriefing/BriefingDialog';
import { CompareMenu } from '_components/Comparator/Menu';
import { SearchTopics } from '_components/SearchTopic/SearchTopics';
import { usePublicAppContext } from '_core/context/public-app-context';
import { useExpertises } from '_core/repos/expertises.repo';
import { getPublicApiRequestHomeLink, PublicApiRepo, useGetLinks } from '_core/repos/public-api.repo';
import { useDomain } from '_core/repos/public-api/domain.repo';

import { Layout, LayoutProps } from './Layout';
import { ProjectBanner } from './ProjectBanner';
import { SubNav } from './SubNav';

export const LayoutPagesRouter = (props: LayoutProps) => {
  const { children, showSubnav, showRankUpdated = false, ...restProps } = props;

  const { domainInfo, locale } = usePublicAppContext();
  const router = useRouter();
  const url = getPublicApiRequestHomeLink(domainInfo?.getOriginUrl() || '', locale);

  const { t } = useTranslation(['common', 'home']);
  const { data: expertises } = useExpertises();
  const { data: domain } = useDomain(domainInfo?.getOriginUrl() ?? '');
  const { data: links } = useGetLinks(url);
  const { data: homepageLinks } = useGetLinks(PublicApiRepo.publicApiNavBarUrl);

  const [isProjectBannerShown, setIsProjectBannerShown] = useState(false);

  // TODO: Uncomment this when project banner is adapted
  // useEffect(() => {
  //   setIsProjectBannerShown(isProjectBannerActive(router.pathname));
  // }, []);
  const navigationData = {
    origin: domainInfo?.getOriginUrl() ?? '',
    locale,
    resolvedUrl: router.asPath,
    domain,
  };

  return (
    <Fragment>
      <Layout
        showRankUpdated={showRankUpdated}
        navigationData={navigationData}
        expertises={expertises}
        links={links}
        t={t}
        briefingCTA={
          <BriefingEmbedButton
            data-testid="briefing-button-navbar-project"
            size="sm"
            buttonStyle="primary"
            buttonVariant="raised"
            className="m-0"
            label={t('common:navbar.menu.postAProject')}
            truncate={false}
            cta="navbar-need"
          />
        }
        search={
          <SearchTopics
            cta="hero"
            type="service"
            page="search-landing"
            element="search-landing"
            placeholder={t('common:navbar.menu.whatService')}
            navigationData={navigationData}
          />
        }
        searchMobile={
          <SearchTopics
            cta="hero"
            type="service"
            page="search-landing"
            element="search-landing"
            placeholder={t('common:navbar.menu.whatService')}
            navigationData={navigationData}
            mobile
          />
        }
        comparatorCTA={<CompareMenu />}
        {...restProps}>
        {/* Should be on layout actually but is not used for now. */}
        {isProjectBannerShown && <ProjectBanner setIsProjectBannerShown={setIsProjectBannerShown} />}
        {showSubnav ? <SubNav otherString={t('home:sections.catalog.others_v1')} links={homepageLinks} /> : null}
        {children}
      </Layout>
      <BriefingDialog />
    </Fragment>
  );
};
